import { ExclamationCircleIcon } from "@heroicons/react/outline";
import { FormEvent, useEffect, useState } from "react";
import useStore from "../store/store";
import dialogPolyfill from "../utils/diaglog-polyfill";

type bulkErrorPropsType = {
  errorMessages: string[];
};

const ShiftDeleteNotPossibelModal = ({ errorMessages }: bulkErrorPropsType) => {
  useEffect(() => {
    var dialog = document.querySelector("#bulkUploadError");
    //@ts-ignore
    dialogPolyfill.registerDialog(dialog);
  }, []);

  return (
    <dialog
      id="bulkUploadError"
      className="border-none rounded-xl py-5 px-10 min-w-[500px] fixed left-0 top-0 mt-0"
    >
      <div className="flex items-center w-full justify-between">
        <h3 className="uppercase font-bold">Bulk uploaden van data mislukt</h3>
        <button
          className="text-3xl"
          onClick={() => {
            //@ts-ignore
            document.getElementById("bulkUploadError")?.close();
          }}
          type="reset"
        >
          &times;
        </button>
      </div>

      <div className="flex justify-center items-center flex-col">
        <ExclamationCircleIcon
          className="text-red mt-7"
          width={80}
        ></ExclamationCircleIcon>
        <p className="text-center text-blue mt-7">
          De CSV data bevat fouten waardoor het uploaden is mislukt. <br />{" "}
          Onderstaande fouten werden gedetecteerd:
        </p>
        <div className="overflow-y-scroll mt-7 max-h-32 list-disc w-full text-red">
          <ul className="list-disc">
            {errorMessages.map((errorMessage, index) => {
              return (
                <li className="list-disc" key={index}>
                  {errorMessage}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </dialog>
  );
};

export default ShiftDeleteNotPossibelModal;
